export default "__VITE_ASSET__ymU4658x__"